import { render, staticRenderFns } from "./Smileys.vue?vue&type=template&id=c50410fa&"
import script from "./Smileys.vue?vue&type=script&lang=js&"
export * from "./Smileys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports